import { render, staticRenderFns } from "./afterSalesNews.vue?vue&type=template&id=cd2235ee&scoped=true&"
import script from "./afterSalesNews.vue?vue&type=script&lang=js&"
export * from "./afterSalesNews.vue?vue&type=script&lang=js&"
import style0 from "./afterSalesNews.vue?vue&type=style&index=0&id=cd2235ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd2235ee",
  null
  
)

export default component.exports